<template>
    <div class="files-list-box wrapperForm">
        <v-row dense class="attachments-content-row">
            <v-col cols="auto" class="section-wrapper attachments-left-menu" v-show="!this.richEditState">
                <v-card
                    class="cloud-file-list-box"
                    flat
                    width="300"
                >
                    <v-card-text>
                        <div class="form-box-title title-with-right-part alm-title">
                            <span>{{$t('Вложения')}}</span>
                            <div class="twrp-content">
                                <v-chip 
                                    v-show="isDownloadAllVisible"
                                    class="table-label"
                                    small
                                    label
                                    color="teal"
                                    dark
                                    @click="loadAllAttchments"
                                >
                                    <div class="d-flex align-center">
                                        <v-icon>fas fa-file-download</v-icon>
                                        {{ $t("Скачать_все") }}
                                    </div>
                                </v-chip>
                            </div>
                        </div> 
                        <div class="cloud-items-container">
                            <div v-if="!groupedAttachments.length" class="cfl-placeholder" >{{$t('Нет_файлов')}}</div>
                            <v-row 
                                v-else 
                                v-for="group in groupedAttachments"
                                :key="group[0]"
                                class="cfl-group-wrap"
                                no-gutters
                            >
                                <v-col cols="12" sm="12" md="12" v-if="groupedAttachments.length > 1" class="cfl-group-title">{{getGroupName(group[0])}}</v-col>
                                <v-col cols="12" sm="12" :md=" groupedAttachments.length > 1 ? '12' : '12'" class="cfl-group-items">
                                    <v-row dense>
                                        <v-col 
                                            cols="12" sm="12" md="12"
                                            class="cfl-item-wrap"
                                            v-for="attachment in group[1]" 
                                            :key="attachment.Id"
                                        >
                                            <div 
                                                class="cfl-item"
                                                :class="{ 'active-cfl': attachment.Id == selecteAttachmentId }"
                                                @click="onAttachmnentClick(attachment)"
                                            >
                                                <div 
                                                    v-if="attachment.Progress"
                                                    class="cfl-item-progress"
                                                    :style="{ width: attachment.Progress }"
                                                >
                                                </div>
                                                <div class="file-icon">
                                                    <!--Для добавления стикера сертификата на иконку добавляем у тега <i> к существующим классам класс with-cert и еще второй класс для управления цветом success-cert или danger-cert -->
                                                    <v-icon :color="getIconColor(attachment.Extension)">
                                                        {{ getIcon(attachment.Extension) }}
                                                    </v-icon>
                                                </div>
                                                <div class="cfl-info">
                                                    <div class="cfl-abs" v-tooltip.left-center="getAttachmentName(attachment)">
                                                        <div class="cfl-filename">{{ getAttachmentName(attachment) }}</div>
                                                        <div>
                                                            <div class="cfl-fileinfo">
                                                                <div v-if="attachment.Message" class="cfl-err-msg">{{ attachment.Message }}</div>
                                                                <span v-else-if="attachment.Progress">{{ attachment.Progress }}</span>
                                                                <span v-else>{{ parseInt(attachment.Length) ? `${(parseFloat(attachment.Length) / (1024 * 1024)).toFixed(2)} ${$t('МБ')}` : '-' }}</span>                                                
                                                            </div>
                                                            <!-- <div class="cfl-status"></div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="cfl-actions"
                                                    v-if="!attachment.Progress"
                                                >
                                                    <span 
                                                        v-tooltip.left-center="$t('Информация_о_файле')"
                                                        @click="openInfoModal(attachment)"
                                                    >
                                                        <i class="fas fa-info-circle dark-gray-color"></i>
                                                    </span>
                                                    <span 
                                                        v-if="!attachment.Message && !attachmentIsReportTemplate(attachment)"
                                                        class="download-file" 
                                                        v-tooltip.left-center="$t('Загрузить')"
                                                        @click.stop="loadAttchment(attachment)"
                                                    >
                                                        <i class="fas fa-download dark-gray-color"></i>
                                                    </span>
                                                    <span
                                                        v-if="!attachment.IsReadOnly && !attachmentIsReportTemplate(attachment) && ( !isDocument || isExistedDocument ) && !isDocumentIsArchive" 
                                                        class="delete-file"
                                                        v-tooltip.left-center="$t('Удалить')"
                                                        @click.stop="deleteAttachment(attachment)"
                                                    >
                                                        <i class="fas fa-trash dark-gray-color"></i>
                                                    </span> 
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <div class="cfl-break"></div>
                        </div> 
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="section-wrapper">
                <v-card
                    v-if="!hidePreviewWarningMessage"
                    class="file-preview-attention-card"
                    flat
                >
                    <v-card-text>
                        <div class="form-box-title attention-box-title fbt-slider-title">
                            <span>{{ $t("Внимание") }}</span>
                            <div class="fbt-slider">
                                <div class="prev-title">{{ $t('Больше_не_показывать') }}</div>
                                <v-switch 
                                    class="cust-switch" 
                                    inset 
                                    hide-details
                                    v-model="hidePreviewWarningMessage"
                                ></v-switch>
                            </div>
                        </div>
                        <v-row no-gutters>
                            <v-col  cols="12" sm="12" md="12">
                                <div class="onlyReadData">
                                    {{ $t('Предпросмотр_предупреждение') }}   
                                </div>
                            </v-col>
                        </v-row>                        
                    </v-card-text>
                </v-card>

                
                <v-card 
                    class="file-preview"
                    v-show="isPreviewVisible"
                    flat
                >
                    <v-card-text>
                        <FilePreview
                            ref="filePreviewComponent"
                            :calculatedEditorHeight="calculatedEditorHeight"
                            @height-control-method="heightControlMethod"
                            @togille-fullscreen-for-attachment="toggleFullscreen"
                        />
                    </v-card-text>
                </v-card>
                
            </v-col>    
        </v-row>

        <FileInfoDlg ref="FileInfoDlgRef" />
    </div>
</template>

<script>
import FileInfoDlg from '@/components/global/dialogs/FileInfoDlg';
import { httpAPI, errorHandler } from "@/api/httpAPI";
import { mapActions, mapGetters, mapMutations } from 'vuex';
import FilePreview from '@/components/global/FilePreview.vue'

export default {
    name: "attachments-tab",
    components: {
        FileInfoDlg,
        FilePreview
    },
    get groupNames() {
        return [
            "Прочие",            
            "Входящие",            
            "Уведомления",            
            "Уведомления_на_подписание",            
            "Ответ", 
            "Дополнительно"          
    ]},
    props: {
        id: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            noPreviewMessage: null,
            isPreviewVisible: true,
            forceUpdate: 0,
            // для richText editor
            calculatedEditorHeight: '500px',
        }
    },
    computed: {
        ...mapGetters('global/actionsource', 
        { 
            documentSource: 'getDataSource', 
            isDocumentIsArchive: 'isDocumentIsArchive', 
            dataSourceType: 'getDataSourceType',
            isCommon: 'isDataSourceCommon'
        }),
        ...mapGetters('global/attachments',
        {
            dataSource: 'getDataSource',
            fileExtensionsAssociationIcons: 'getFileExtensionsAssociationIcons',
            fileExtensionsAssociationIconsColors: 'getFileExtensionsAssociationIconsColors',
            selecteAttachmentId: 'getSelectedAttachmentId'            
        }),
        groupedAttachments() {
            let groupedAttachments = this.$_.groupBy(this.dataSource, (item) => {
                return item.Group;
            });
            
            Object.keys(groupedAttachments).forEach((key) => {            
                groupedAttachments[key] = groupedAttachments[key].map(x => x).sort(function (a, b) { return a.Name.localeCompare(b.Name); });
            });

            return Object.entries(groupedAttachments);
        },
        activeItem() {
            //return this.dataSource?.find(i => i.IsActive);
            return this.dataSource?.find(i => i.Id == this.selecteAttachmentId);
        },
        activeItemInfo() {
            return {
                Version: this.activeItem?.Version ?? '-',
                Author: this.activeItem?.Author ?? '-',
                IsReadOnly: this.activeItem != null ? this.activeItem.IsReadOnly ? this.$t("Да") : this.$t("нет") : '-',
                RecDate: this.activeItem?.RecDate ?? '-',
                Description: this.activeItem?.Description
            }
        },
        isDownloadAllVisible() {
            if (this.dataSourceType === 'ReportQuery'){
                return this.dataSource.filter(item => item.Id != this.documentSource.Data.Object.Document.SchemaAttachmentId && item.Id != this.documentSource.Data.Object.Document.TemplateAttachmentId).length > 1;
            }
            else 
                return this.dataSource?.length > 1;
        },
        isDocument() {
            return this.documentSource?.Data?.Object?.Document != null;
        },
        isExistedDocument() {
            return this.documentSource?.Data?.Object?.Document?.is_new_record === false;
        },
        hidePreviewWarningMessage: {
            get: function() {
                this.forceUpdate;
                return JSON.parse(localStorage.getItem('PREVIEWS_WARN_MSG_HIDDEN') ?? 'false')
            },
            set: function(v) {
                localStorage.setItem('PREVIEWS_WARN_MSG_HIDDEN', v);
                this.forceUpdate++;
            }
        },
        richEditState:{
            get: function() {
                return this.$store.getters[[`global/filePreview/getRichEditState`]];
            },
            set: function(v) {
                this.$store.commit(`global/filePreview/SET_RICHEDITSTATE`, v);
            }
        }
    },
    mounted() {
        this.$emit('onMounted');
        this.$nextTick(this.heightControlMethod);
        window.addEventListener('resize', this.heightControlMethod);
         
        this.$refs.filePreviewComponent.richEditResetStates()
    },
    created() {
        this.update();
        this.$emit('onCreated');
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.heightControlMethod);
    },
    watch: {
        hidePreviewWarningMessage() {
            this.$nextTick(function() {
                this.heightControlMethod();
            });
        },
        // Отслеживаем, когда таб становится не активным
        '$parent.isActive'(isVisible) {
            if (!isVisible) {
                // возвращаем режим просмотра не редакторе, если покинули вкладку
                if (this.$refs.filePreviewComponent)
                    this.$refs.filePreviewComponent.richEditResetStates();
            }
        },
        activeItem(val){
            this.$refs.filePreviewComponent.setAttachment(val);
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        ...mapActions('global/actionsource', ['setActiveTabName']),
        ...mapActions('global/attachments', ['setCurrentDocumentId', 'updateDataSource', 'deleteAttachment', 'setDataSource']),
        ...mapMutations('global/attachments', { setDataSource: 'SET_DATASOURCE' }),        
        async update() {
            if (this.$parent.isActive)
                this.setActiveTabName('attachments-tab');
            if (this.$refs.filePreviewComponent)
                this.$refs.filePreviewComponent.richEditResetStates()
            this.setDataSource({ dataSource: [] });
            this.setOverlayVisible({ visible: true });
            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel(`$Предпросмотр_вложения_<${this.prevAttchName}}>_отменен.message`);
            await this.setCurrentDocumentId(this.id);
            await this.updateDataSource();
            this.setOverlayVisible({ visible: false });      
            this.$eventBus.$emit('tab-0202010-updated');      
        },
        attachmentIsReportTemplate(item) {
            return this.dataSourceType === 'ReportQuery' && (item.Id == this.documentSource.Data.Object.Document.SchemaAttachmentId || item.Id == this.documentSource.Data.Object.Document.TemplateAttachmentId);
        },
        onAttachmnentClick(item) {
            if (item.Progress || item.Message || item.Id == this.selecteAttachmentId)
                return;
            this.$store.commit('global/attachments/SET_SELECTED_ATTACHMENT_ID', item.Id);
        },
        async loadAttchment(item) {
            this.$eventBus.$emit('on-download-file', { id: item.Id, name: item.Name, });
        },        
        async loadAllAttchments() {
            let type = "doc";

            if (this.dataSourceType === 'Order')
                type = "order";

            if (this.dataSourceType === 'Meeting')
                type = "meeting";
            
            // формируем URL
            let request = httpAPI(
            { 
                url: `api/download/attachments?id=${this.id}&type=${type}`, 
                method: 'GET', 
                responseType: 'blob', 
                skipErrorHandler: true,
                headers: { 'isCommon': this.isCommon }
            });
            
            // при успешном выполнении запроса на формирование отчёта выполнить:
            var onResolve = (response) => {
                this.$notify.success(`Загрузка файла ${name} завершена`);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Attachments.zip');
                document.body.appendChild(link);
                link.click();
            };
            // при неудачном выполнении запроса на формирование отчёта выполнить:
            var onReject = (error) => {
                errorHandler(error);
            };

            let asyncReportToastMessage = `Загрузка вложений`;
            this.$notify.async(request, onResolve, onReject, asyncReportToastMessage, { icons: { enabled: true } });
        },
        addAttachment() {
            this.$refs.inputFile.click()
        },
        getGroupName(v) {
            return this.$options.groupNames[v] ? this.$t(this.$options.groupNames[v]) : '';
        },
        async openInfoModal(attachment) {
            try
            {
                this.onAttachmnentClick(attachment);
                await this.$refs.FileInfoDlgRef.open({ ParentType: this.$store.getters['global/actionsource/getDataSourceType'], ...attachment });
            }
            catch (ex)
            {
                console.log(ex);
            }
        },
        getAttachmentName(attachment) {

            if (this.$store.getters['global/actionsource/getDataSourceType'] === 'IQalaStatement' && attachment.Description != null && typeof attachment.Description === 'string' && attachment.Description.length > 0)
                return attachment.Description;

            return attachment.Name;
        },
        getIcon(fileExtension) {

            if (fileExtension != null && typeof fileExtension === 'string' && fileExtension.length > 0) {
                return this.fileExtensionsAssociationIcons[fileExtension.replace('.', '')] ?? 'fas fa-file';
            }

            return 'fas fa-file';
        },
        getIconColor(fileExtension) {

            if (fileExtension != null && typeof fileExtension === 'string' && fileExtension.length > 0) {
                return this.fileExtensionsAssociationIconsColors[fileExtension.replace('.', '')] ?? '#b4b4b4';
            }

            return '#b4b4b4';
        },
        heightControlMethod() {
            var parent = document.getElementsByClassName('content-box')[0];
            var top_btns_bar_obj = parent.getElementsByClassName('top-btns-bar');
            var white_panel_obj = parent.getElementsByClassName('white-panel-items');
            var tab_selector_panel_obj = parent.getElementsByClassName('tab-selector-panel');
            var after_tabs_card_btn_obj = parent.getElementsByClassName('after-tabs-part-wrapper');
            var alm_title_obj = parent.getElementsByClassName('alm-title');
            var cloud_items_container_obj = parent.getElementsByClassName('cloud-items-container');
            var file_preview_attention_card_obj = parent.getElementsByClassName('file-preview-attention-card');
            var file_preview_box_title_obj = parent.getElementsByClassName('file-preview-box-title');
            var file_preview_iframe_obj = parent.getElementsByClassName('file-preview-iframe');
            
            var parent_h = parent.clientHeight;

            var toolbar_h = 0;
            if(top_btns_bar_obj.length > 0){
                toolbar_h = top_btns_bar_obj[0].clientHeight + 10;
            }else{
                toolbar_h = 5;
            }

            var white_panel_h = 0;
            if(white_panel_obj.length > 0){
                Array.from(white_panel_obj).forEach(el => {
                    white_panel_h += el.clientHeight + 10;
                });
            }
            
            var tabs_margin_top = white_panel_obj.length > 0 ? 10 : 0;
            var after_tabs_card_btn_h = after_tabs_card_btn_obj.length > 0 ? after_tabs_card_btn_obj[0].clientHeight : 
            tab_selector_panel_obj[0].clientHeight;
            var alm_title_h = alm_title_obj.length > 0 ? alm_title_obj[0].clientHeight : 0;
            var file_preview_attention_card_h = file_preview_attention_card_obj.length > 0 ? file_preview_attention_card_obj[0].clientHeight + 16 : 0;
            var file_preview_box_title_h = file_preview_box_title_obj.length > 0 ? file_preview_box_title_obj[0].clientHeight : 0;
            //растягиваем меню выбора и области просмотра для вложений на высоту экрана    
            //для меню слева
            cloud_items_container_obj[0].style.height = (parent_h - (toolbar_h + white_panel_h + tabs_margin_top + after_tabs_card_btn_h + alm_title_h + 57)) + "px";
            // считаем общую высоту для iframe и для редактора richEdit
            let commonHeight = (parent_h - (toolbar_h + white_panel_h + tabs_margin_top + after_tabs_card_btn_h + file_preview_box_title_h + file_preview_attention_card_h + 81)) + "px"
            //для iframe предпросмотра
            file_preview_iframe_obj[0].style.height = commonHeight;
            // высота для редактора
            this.calculatedEditorHeight = commonHeight;
        },
        toggleFullscreen() {
            this.$nextTick(() => {
                const btn = document.querySelector('.dxre-icon-FullScreen')?.closest('[role="button"]');
                if (btn) {
                    btn.click();
                }
            });
        },
    }
}
</script>